<gtd-widgets-info-layout [isLoading]="isLoading" (onRefresh)="getData()">
  <p500-ui-cube-preloader *ngIf="isLoading"></p500-ui-cube-preloader>
  <div class="c-widget--info c-widget--info--white" *ngIf="!isLoading" [ngClass]="customClass">
    <ul>
      <li class="title" i18n="@@common.basic_information">Basic Information</li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.tracker_type">Tracker Type</span>: </span>
          <span class="value" i18n="@@common.default">Default</span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.type">Type</span>: </span>
          <span class="value">
            <gtd-ui-field-special-affiliates-trackers-type [data]="data.type"></gtd-ui-field-special-affiliates-trackers-type>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.status">Status</span>: </span>
          <span class="value">
            <gtd-postback-status [archived]="data.archived" [status]="data.status"></gtd-postback-status>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.content">Content</span>: </span>
          <span class="value">
            <gtd-ui-field-default-string [data]="data.content"></gtd-ui-field-default-string>
          </span>
        </p>
      </li>
    </ul>
    <ul>
      <li class="title" i18n="@@common.additional">Additional</li>
      <li *ngIf="data.hasOwnProperty('affiliate')">
        <p>
          <span class="key"> <span i18n="@@common.affiliate">Affiliate</span>: </span>
          <span class="value cut-overflow">
            <gtd-ui-field-dynamic type="affiliate" [data]="data?.affiliate"></gtd-ui-field-dynamic>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.offer">Offer</span>: </span>
          <span class="value cut-overflow">
            <gtd-ui-field-dynamic type="offer" [data]="data?.offer"></gtd-ui-field-dynamic>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.goal">Goal</span>: </span>
          <span class="value cut-overflow">
            <gtd-ui-field-dynamic type="goal-relation-link" [data]="data?.goal"></gtd-ui-field-dynamic>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.goal_type">Goal Type</span>: </span>
          <span class="value">
            <gtd-ui-field-dynamic type="string" [data]="data?.goal_type?.name"></gtd-ui-field-dynamic>
          </span>
        </p>
      </li>
    </ul>
    <ul>
      <li class="title" i18n="@@common.timestamps">Timestamps</li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.created_at">Created At</span>: </span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.created_at * 1000"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.updated_at">Updated At</span>: </span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.updated_at * 1000"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
    </ul>
  </div>
</gtd-widgets-info-layout>
